export const SideBarData = [
  {
    title: "Willkommen",
    link: "/home",
  },
  {
    title: "Programm",
    link: "/dates",
  },
  /*{
        title: "Anmeldung",
        link: "/register"
    },*/
  {
    title: "Über uns",
    link: "/aboutus",
  },
  {
    title: "Links",
    link: "/links",
  },
  {
    title: "Dateien",
    link: "/files",
  },
  /*{
        title: "Aufgaben",
        link: "/exercises"
    },*/
  {
    title: "Kontakt",
    link: "/contact",
  },
];
